export const FINANCIAL_REFERENCE_PATTERN =
  "[A-Za-z0-9][A-Za-z0-9._:\\-]{1,159}";

/** datetime-local expects wall-clock fields, not a UTC ISO string. */
export function localDateTimeInputValue(date = new Date()): string {
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function updateRevenueDrafts(
  current: ReadonlySet<string>,
  id: string,
  dirty: boolean,
): ReadonlySet<string> {
  if (current.has(id) === dirty) return current;
  const next = new Set(current);
  if (dirty) next.add(id);
  else next.delete(id);
  return next;
}
